// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError} from "@reduxjs/toolkit/query";
import { getAuthToken, handleUnauthorized } from "../utils/authSession.js";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// initialize an empty api service that we'll inject endpoints into later as needed
const rawBaseQuery = fetchBaseQuery({
  baseUrl: `${BASE_URL}/api/`,
  prepareHeaders: (headers) => {
    const authToken = getAuthToken();
    if (authToken) {
      headers.set("Authorization", `Token ${authToken}`);
    }
    return headers;
  },
});

const getHttpStatus = (
  error: FetchBaseQueryError | undefined,
): number | undefined => {
  if (!error) {
    return undefined;
  }

  if (typeof error.status === "number") {
    return error.status;
  }

  if (
    error.status === "PARSING_ERROR" &&
    typeof error.originalStatus === "number"
  ) {
    return error.originalStatus;
  }

  return undefined;
};

const baseQueryWithAuthHandling: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, baseQueryApi, extraOptions) => {
  const tokenAtRequestStart = getAuthToken();

  const result = await rawBaseQuery(
    args,
    baseQueryApi,
    extraOptions,
  );

  const status = getHttpStatus(result.error);

  if (status === 401 && tokenAtRequestStart) {
    handleUnauthorized(tokenAtRequestStart);
  }

  return result;
};

export const api = createApi({
  baseQuery: baseQueryWithAuthHandling,
  endpoints: () => ({}),
});
